module.exports = __webpack_public_path__ + "img/steps.fbe8b67c.svg";